import Route from '@ember/routing/route';

export default class SchoolSwitchingRoute extends Route {}
